import { Stack, TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { ChatMessageFormValues } from "./chat-message-form.types";

interface QuestionRewardProps {
  control: Control<ChatMessageFormValues>;
  textName: "question.text";
  textLabel?: string;
  rewardName: "question.reward";
}

const QuestionReward: FC<QuestionRewardProps> = ({
  control,
  textName,
  textLabel = "Question",
  rewardName,
}) => {
  return (
    <Stack direction="row" gap={2} flex={1}>
      <Controller
        control={control}
        name={textName}
        defaultValue=""
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="text"
            label={textLabel}
            sx={{ flex: 5, minWidth: 200 }}
          />
        )}
      />
      <Controller
        control={control}
        name={rewardName}
        defaultValue={undefined}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            margin="normal"
            fullWidth
            InputLabelProps={{ shrink: true }}
            type="number"
            label="Récompense"
            onChange={(event) => field.onChange(Number(event.target.value))}
            sx={{ width: 200 }}
          />
        )}
      />
    </Stack>
  );
};

export default QuestionReward;
